(() => {
  const initialiseProduct = (root) => {
    if (!root || root.dataset.braidelleReady === 'true') return;
    root.dataset.braidelleReady = 'true';

    const gallery = root.querySelector('[data-braidelle-gallery]');
    if (gallery) {
      const track = gallery.querySelector('[data-braidelle-gallery-track]');
      const slides = Array.from(gallery.querySelectorAll('[data-braidelle-gallery-slide]'));
      const previous = gallery.querySelector('[data-braidelle-gallery-previous]');
      const next = gallery.querySelector('[data-braidelle-gallery-next]');
      const dots = Array.from(gallery.querySelectorAll('[data-braidelle-gallery-dot]'));
      const current = gallery.querySelector('[data-braidelle-gallery-current]');
      let activeIndex = 0;
      let scrollFrame;

      const updateGallery = (index) => {
        if (!slides.length) return;
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (current) current.textContent = String(activeIndex + 1);
      };

      const goToGalleryImage = (index, behavior = 'smooth') => {
        if (!track || !slides.length) return;
        const wrappedIndex = (index + slides.length) % slides.length;
        track.scrollTo({ left: slides[wrappedIndex].offsetLeft, behavior });
        updateGallery(wrappedIndex);
      };

      previous?.addEventListener('click', () => goToGalleryImage(activeIndex - 1));
      next?.addEventListener('click', () => goToGalleryImage(activeIndex + 1));
      dots.forEach((dot) => {
        dot.addEventListener('click', () => goToGalleryImage(Number.parseInt(dot.dataset.galleryIndex, 10) || 0));
      });

      track?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goToGalleryImage(activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goToGalleryImage(activeIndex + 1);
        }
      });

      track?.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const closestIndex = slides.reduce((closest, slide, index) => {
            const currentDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
            const closestDistance = Math.abs(slides[closest].offsetLeft - track.scrollLeft);
            return currentDistance < closestDistance ? index : closest;
          }, 0);
          updateGallery(closestIndex);
        });
      }, { passive: true });

      updateGallery(0);
    }

    const form = root.querySelector('.brd-product-form');
    if (!form) return;

    const variantInput = form.querySelector('[data-braidelle-variant-id]');
    const variantButtons = Array.from(form.querySelectorAll('[data-braidelle-variant]'));
    const price = root.querySelector('[data-braidelle-price]');
    const compare = root.querySelector('[data-braidelle-compare]');
    const submit = form.querySelector('[data-braidelle-submit]');
    const submitLabel = form.querySelector('[data-braidelle-submit-label]');
    const status = form.querySelector('[data-braidelle-status]');
    const availability = root.querySelector('[data-braidelle-availability]');
    const availabilityLabel = root.querySelector('[data-braidelle-availability-label]');
    const quantity = form.querySelector('[data-braidelle-quantity] input');
    const minus = form.querySelector('[data-quantity-minus]');
    const plus = form.querySelector('[data-quantity-plus]');

    const chooseVariant = (button, updateUrl = true) => {
      if (!button || button.disabled) return;

      variantButtons.forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      const available = button.dataset.variantAvailable === 'true';
      variantInput.value = button.dataset.variantId;
      if (price) price.textContent = button.dataset.variantPrice;

      if (compare) {
        const comparePrice = button.dataset.variantCompare || '';
        compare.textContent = comparePrice;
        compare.hidden = comparePrice.length === 0;
      }

      if (submit) submit.disabled = !available;
      if (submitLabel) submitLabel.textContent = available ? 'Add to Bag' : 'Sold Out';
      if (status) status.textContent = available ? '' : 'This length is currently unavailable.';
      if (availability) availability.classList.toggle('is-unavailable', !available);
      if (availabilityLabel) availabilityLabel.textContent = available ? 'In Stock' : 'Sold Out';

      if (updateUrl && button.dataset.variantUrl && window.history?.replaceState) {
        window.history.replaceState({}, '', button.dataset.variantUrl);
      }
    };

    variantButtons.forEach((button) => {
      button.setAttribute('aria-pressed', button.classList.contains('is-selected') ? 'true' : 'false');
      button.addEventListener('click', () => chooseVariant(button));
    });

    const selectedButton = variantButtons.find((button) => button.classList.contains('is-selected') && !button.disabled);
    const firstAvailableButton = variantButtons.find((button) => !button.disabled);
    chooseVariant(selectedButton || firstAvailableButton, false);

    minus?.addEventListener('click', () => {
      const current = Math.max(1, Number.parseInt(quantity.value, 10) || 1);
      quantity.value = Math.max(1, current - 1);
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });

    plus?.addEventListener('click', () => {
      const current = Math.max(1, Number.parseInt(quantity.value, 10) || 1);
      quantity.value = current + 1;
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });

    quantity?.addEventListener('change', () => {
      const value = Math.max(1, Number.parseInt(quantity.value, 10) || 1);
      quantity.value = value;
    });
  };

  const initialiseAll = () => {
    document.querySelectorAll('[data-braidelle-product]').forEach(initialiseProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);
})();
